export enum AssetTypeName {
  DEVICE = 'device',
  USER = 'user',
  GROUPING = 'grouping',
}

export enum AssetTypeId {
  DEVICE = 1,
  USER = 2,
  GROUPING = 3,
}

export interface AssetType {
  id: AssetTypeId;
  name: AssetTypeName;
}
